import React from 'react';
import { View, Image, type Styles } from '@react-pdf/renderer';

import { PhotoCaption } from './PhotoCaption';

/**
 * Una foto del informe con su pie (nombre y, si la hay, ubicación).
 *
 * 🔴 Es UNA pieza que no se parte (`wrap={false}`): si no cabe al final de la
 * página, pasa entera a la siguiente. Sin esto react-pdf podía dejar la imagen
 * abajo y llevarse las coordenadas a la página siguiente, donde parecían de
 * otra cosa (informe de Su.0000615 en beta, 2026-10-09).
 */
export const PhotoCell = ({
  url,
  name,
  location,
  cellStyle,
  imageStyle,
  captionStyle,
}: {
  url: string;
  name: string;
  location?: string[];
  cellStyle: Styles[string];
  imageStyle: Styles[string];
  captionStyle: Styles[string];
}) => (
  <View style={cellStyle} wrap={false}>
    <Image style={imageStyle} src={url} />
    <PhotoCaption name={name} location={location} nameStyle={captionStyle} />
  </View>
);

export default PhotoCell;
